import React, { Fragment, useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import axios from "axios";
import { Card, Carousel, Col, Container, Row } from "react-bootstrap";
import TimerCountDown from "./TimerCountDown"
import { Button, Dimmer, Divider, Icon, Label, Loader, Placeholder } from "semantic-ui-react";
import { useMyGlobal } from "./GlobalData";
import { useNavigate } from "react-router-dom";
import { IoFlash } from "react-icons/io5";
import { FaCommentsDollar } from "react-icons/fa";

const Flashsale = ({ dataFs }) => {
    const navigate = useNavigate()
    const [productsFs, setProductsFs] = useState([])
    const idCustomer = (localStorage.getItem('loginData')) ? JSON.parse(localStorage.getItem('loginData')).id : null
    const [currentTime, setCurrentTime] = useState(1)
    const { token, wishData, windowWidth, isPortrait } = useMyGlobal()
    const [placeholder, setPlaceholder] = useState(true)
    const [hasMore, setHasMore] = useState(false);
    const [page, setPage] = useState(0)
    const [loadFS, setLoadFS] = useState(false)
    const groupedData = []
    const itemsPerCarousel = (() => {
        if (windowWidth <= 700) {
            return 2
        } else if (windowWidth <= 1200 && windowWidth > 700) {
            return 4
        } else {
            return 6
        }
    })()

    for (let i = 0; i < productsFs.length; i += itemsPerCarousel) {
        groupedData.push(productsFs.slice(i, i + itemsPerCarousel));
    }

    const handleClickLoadMore = () => {
        if (!loadFS && hasMore) {
            setPage(prev => {
                const next = prev + 12;
                getFSProd(dataFs[0].id_fs, next);
                return next;
            });
        }
    }

    useEffect(() => {
        //console.log("test page")
    }, []);

    const getFSProd = async (id_fs, offset = 0) => {
        setLoadFS(true)
        const param = {
            id_fs: id_fs,
            id_customer: idCustomer,
            jumlah: 12,
            halaman: offset > 0 ? offset : 0,
        }

        await axios({
            method: "POST",
            url: `${process.env.REACT_APP_SRV_API_URL}controler/event.php/?index=1`,
            headers: {
                'Content-Type': 'text/plain',
                'Authorization': token
            },
            data: param
        })
            .then(res => {
                if (res.data.state === 200) { 
                    if (res.data.data?.length > 0 && currentTime > 0) {
                        setProductsFs([...productsFs, ...res.data.data])
                        setHasMore(true)
                        setPlaceholder(false)
                        setLoadFS(false)
                    } else {
                        setHasMore(false)
                        setPlaceholder(false)
                        setLoadFS(false)
                    }
                }
            })
    }

    const handleClickViewAll = (product) => {
        navigate('/product/flashsaleProductPage', { state: product })
    }

    useEffect(() => {
        //console.log(dataFs[0].id_fs)
        getFSProd(dataFs[0].id_fs)
    }, [])

    useEffect(() => {
        if (productsFs.length > 0) {
            setPlaceholder(false)
        }
    }, [productsFs])

    // useEffect(() => {
    //     if (!loadFS && page > 0) {
    //         getFSProd(dataFs[0].id_fs)
    //     }
    // }, [loadFS, page])

    return (
        <>
            {dataFs.length > 0 &&
                dataFs.map((fsItem, idx) => (
                    <Container fluid className="mt-4 mb-4" key={idx}>
                        <React.Fragment>
                            <Row>
                                <Col md={12} className="text-start">
                                    <div className="text-center mb-3"><IoFlash className="fs-2" /></div>
                                    <Divider horizontal className="mb-4"><h1 className="fs-6">{fsItem.name}</h1></Divider>
                                    {/* <Label content={(fsItem.name)} icon="tags" className="fs-5 mb-5" basic color="black" /> */}
                                    <div>
                                        <span className="me-3">END ON</span>
                                        <span className="fw-bold fs-5">
                                            <p>{<TimerCountDown expiryTime={(fsItem.date_end)} setCurentTime={setCurrentTime} sendTime={true} />}</p>
                                        </span>
                                    </div>
                                </Col>
                            </Row>
                            {/* <Row >
                                <Col>
                                    <Row className="mt-2 justify-content-start">
                                        {
                                            (productsFs.length > 0) ? ( 
                                                productsFs.map((item, i) => {
                                                    const isWish = wishData.some(wishItem => wishItem.id_product === item.id_product);
                                                    return (
                                                        <ProductCard data={item} key={i} option="flashsale" isWish={isWish}/>
                                                    )
                                                })
                                            )
                                                :
                                                <>
                                                    <Col className="text-start mt-3" xxl={2} xl={2} lg={3} md={3} sm={4} xs={6}>
                                                        <Placeholder style={{ width: '100%' }} key={idx}>
                                                            <Placeholder.Header>
                                                                <Placeholder.Image square />
                                                            </Placeholder.Header>
                                                            <Placeholder.Paragraph>
                                                                <Placeholder.Line />
                                                                <Placeholder.Line length="short" />
                                                                <Placeholder.Line length="very short" />
                                                                <Placeholder.Line length="short" />
                                                                <Placeholder.Line length="long" />
                                                            </Placeholder.Paragraph>
                                                        </Placeholder>
                                                    </Col>
                                                </>
                                        }
                                    </Row>
                                </Col>
                            </Row> */}
                            <Row>
                                {
                                    productsFs.length > 0 ?
                                        productsFs.map((item, i) => (
                                            <Col xl={2} lg={3} md={3} sm={6} xs={6} key={i}>
                                                <ProductCard
                                                    data={item}
                                                    option="flashsale"
                                                    isWish={wishData.some(wishItem => wishItem.id_product === item.id_product)}
                                                />
                                            </Col>
                                        ))
                                        :
                                        [...Array(6)].map((_, i) => (
                                        <Col xl={2} lg={3} md={3} sm={6} xs={6} key={i}>
                                            
                                            {/* kita mimic ProductCard structure */}
                                            <div className="mt-3 mb-3">
                                            <Card className="product-card">
                                                
                                                {/* IMAGE CAROUSEL AREA */}
                                                <div style={{ aspectRatio: '9 / 16' }}>
                                                <Placeholder fluid style={{ width: '100%', height: '100%' }}>
                                                    <Placeholder.Image rectangular style={{ width: '100%', height: '100%' }} />
                                                </Placeholder>
                                                </div>

                                            </Card>
                                            </div>

                                        </Col>
                                        ))
                                }
                                {
                                    productsFs.length > 0 && (
                                        <Col className={hasMore ? "d-flex justify-content-center mt-3" : ""} xs={12} sm={12} md={12} lg={12} xl={12}>
                                            {hasMore &&
                                                <Button
                                                    onClick={handleClickLoadMore}
                                                    loading={loadFS}
                                                    content={!loadFS ? "Load more products" : "Loading"}
                                                    icon="refresh"
                                                    basic
                                                    color="black"
                                                    size="small"
                                                />
                                            }
                                        </Col>
                                    )
                                }
                            </Row>
                        </React.Fragment>
                    </Container>
                ))
            }
        </>
    )
}

export default Flashsale